import {Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {
    MeasuringPointLightDto,
    MeasuringPointService,
    MeasuringPointType,
    SearchMeasuringPointResultDto,
    SearchCustomerDto,
    CustomerLightDto
} from '../../../_services/configuration-services';
import {SearchCustomerComponent} from '../../../_shared/_components/search-customer/search-customer.component';
import {SearchMeasuringPointComponent} from '../../../_shared/_components/search-measuring-point/search-measuring-point.component';
import {TranslateService} from '@ngx-translate/core';
import {NotificationsService} from '../../../_shared/notifications.service';
import {RolesService} from '../../../_shared/roles-service';
import {firstValueFrom} from 'rxjs';

@Component({
    selector: 'app-assign-service-measuring-point-modal',
    templateUrl: './assign-service-measuring-point-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssignServiceMeasuringPointModalComponent implements OnInit {

    @Input() serviceId!: string;
    @Input() measuringPoint: MeasuringPointLightDto | null = null;
    @Input() customer: CustomerLightDto | null = null;
    @Input() measuringPointTypeToAdd: MeasuringPointType = MeasuringPointType.Customer;

    customerId: string | null = null;
    measuringPointId: string | null = null;


    editMode: boolean;
    assignCustomerMode = false;
    reassignCustomerMode = false;
    oldMeasuringPointId: string | null = null;

    @ViewChild('searchCustomerComponent') searchCustomer: SearchCustomerComponent;
    @ViewChild('searchMeasuringPointComponent') searchMeasuringPoint: SearchMeasuringPointComponent;

    constructor(public activeModal: NgbActiveModal,
                private readonly translateService: TranslateService,
                private readonly notificationsService: NotificationsService,
                private readonly rolesService: RolesService,
                private readonly measuringPointService: MeasuringPointService) {
    }

    ngOnInit(): void {
        this.assignCustomerMode = this.measuringPoint != null && this.measuringPoint.customer == null;
        this.reassignCustomerMode = this.measuringPoint?.customer != null;
        this.measuringPointId = this.measuringPoint?.id ?? null;

        if (this.reassignCustomerMode) {
            this.oldMeasuringPointId = this.measuringPoint?.id ?? null;
        }

        this.customerId = this.customer?.id ?? null;
    }

    async assignMeasuringPoint(): Promise<void> {
        if (this.measuringPointTypeToAdd === MeasuringPointType.Customer) {
            if (this.reassignCustomerMode) {
                await firstValueFrom(this.measuringPointService.reassignMeasuringPointCustomer(this.serviceId, this.measuringPointId, this.customerId, this.oldMeasuringPointId));
                this.notificationsService.success({title: 'measuringPoints.notifications.reassignSuccess'});
                this.activeModal.close('success');
            } else {
                if (this.customerId) {
                    if (this.editMode) {
                        await firstValueFrom(this.measuringPointService.assignMeasuringPointToCustomer(this.serviceId, this.measuringPointId, this.customerId));

                    } else {
                        await firstValueFrom(this.measuringPointService.assignMeasuringPointToServiceAndCustomer(this.serviceId, this.measuringPointId, this.customerId));
                    }
                    this.notificationsService.success({title: 'measuringPoints.notifications.assignCustomerSuccess'});
                    this.activeModal.close('success');

                } else {
                    await firstValueFrom(this.measuringPointService.assignMeasuringPointToService(this.serviceId, this.measuringPointId));
                    this.notificationsService.success({title: 'measuringPoints.notifications.assignSuccess'});
                    this.activeModal.close('success');
                }
            }
        } else if (this.measuringPointTypeToAdd === MeasuringPointType.Admin) {
            await firstValueFrom(this.measuringPointService.assignMeasuringPointToService(this.serviceId, this.measuringPointId));
            this.notificationsService.success({title: 'measuringPoints.notifications.assignSuccess'});
            this.activeModal.close('success');
        }
    }

    measuringPointSelected(measuringPoint: SearchMeasuringPointResultDto | null): void {
        this.measuringPointId = measuringPoint?.id ?? null;
    }

    customerSelected(customer: SearchCustomerDto | null): void {
        this.customerId = customer?.id ?? null;
    }

    getModalTitle(): string {
        if (this.assignCustomerMode) {
            return this.translateService.instant('measuringPoints.assignModal.assignCustomerTitle');
        }
        if (this.reassignCustomerMode) {
            return this.translateService.instant('measuringPoints.assignModal.reassignCustomerTitle');
        }
        return this.translateService.instant('measuringPoints.assignModal.title');
    }

    public get measuringPointType(): typeof MeasuringPointType {
        return MeasuringPointType;
    }

}
